import * as React from 'react';

import classNames from 'classnames';

interface ISelectProps {
	options: ISelectOption[];
	value?: string | number;
	size?: 'small' | 'normal' | 'medium' | 'large';
	className?: string;
	isLoading?: boolean;
	isFocused?: boolean;
	isHovered?: boolean;
	isDisabled?: boolean;
	isFullWidth?: boolean;
	onChange?: (value: string | number) => void;
}

export interface ISelectOption {
	value: string | number;
	display: string;
}

export default class Select extends React.Component<ISelectProps, {}> {
	public onChange = (event) => {
		if (this.props.onChange) {
			this.props.onChange(event.target.value);
		}
	};

	public render() {
		const {
			size,
			className,
			isLoading,
			isFocused,
			isHovered,
			isDisabled,
			options,
			value,
			isFullWidth,
		} = this.props;

		const divClasses = classNames(
			'select',
			size ? `is-${size}` : '',
			isLoading ? 'is-loading' : '',
			isFullWidth ? 'is-fullwidth' : '',
			className ? className : ''
		);

		const selectClasses = classNames(
			isFocused ? 'is-focused' : '',
			isHovered ? 'is-hovered' : ''
		);

		const selectOptions =
			options &&
			options.map((option) => {
				return (
					<option key={`option-${option.display}`} value={option.value}>
						{option.display}
					</option>
				);
			});

		return (
			<div className={divClasses}>
				<select
					className={selectClasses}
					onChange={this.onChange}
					disabled={isDisabled}
					value={value}
				>
					{selectOptions}
				</select>
			</div>
		);
	}
}
